class PrintPickUpForInvoices {
    constructor(Alert, $http) {
        this.key = 'print-pickup-for-invoices';
        this.title = 'Print PickUp';
        this.level = 'selected';
        this.alert = Alert;
        this.api = $http;
    }

    action({}, store) {
        this.api.post('billing/invoices/bulk-print-pickups', {
            invoices: store.getters.selectedFilters,
        }).then(() => {
            store.dispatch('getData');
            this.alert.success('Pickup started', 'The pickups are getting printed now');
        }, err => this.alert.handle(err))
    }
}

angular
    .module('festzelt-os.billing.invoices')
    .factory('printPickUpForInvoices', [
        'Alert',
        '$http',
        (Alert, $http) => new PrintPickUpForInvoices(Alert, $http)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/workflows/print-pickup-for-invoices.js